import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingPage } from '../components/landing/LandingPage';

/** Public marketing landing (route `/`). Login/register are their own routes. */
const Landing: React.FC = () => {
  const navigate = useNavigate();
  return (
    <LandingPage
      onLogin={() => navigate('/login')}
      onRegister={() => navigate('/register-company')}
    />
  );
};

export default Landing;
